export default "__VITE_ASSET__8aacd150__"